document.addEventListener('DOMContentLoaded', function () {

  function adjustThumbnailSliderWidth() {
    const galleryViewer = document.querySelector('[id^="GalleryViewer"]');
    const thumbnailSlider = document.querySelector('.thumbnail-slider');

    if (!galleryViewer || !thumbnailSlider) return;

    const galleryHeight = galleryViewer.offsetHeight;

    document.documentElement.style.setProperty(
      '--dynamic-slider-width',
      galleryHeight + 'px'
    );
  }

  function setupThumbnailHoverScroll() {
    const thumbnailSlider = document.querySelector('.thumbnail-list.slider--tablet-up');
    if (!thumbnailSlider) return;

    // Remove any previously attached wheel listener to avoid duplicates
    if (thumbnailSlider._wheelHandler) {
      thumbnailSlider.removeEventListener('wheel', thumbnailSlider._wheelHandler);
    }

    // Wheel scroll only — clean, no auto-scroll zones
    thumbnailSlider._wheelHandler = function (e) {
  const sc = document.querySelector('slider-component.thumbnail-slider');
  if (!sc) return;

  const rect = sc.getBoundingClientRect();
  
  // Add 10px inset on left and right to avoid edge bleed
  const inset = 35;
  if (
    e.clientX >= rect.left + inset &&
    e.clientX <= rect.right - inset &&
    e.clientY >= rect.top &&
    e.clientY <= rect.bottom
  ) {
    e.preventDefault();
    e.stopPropagation();
    thumbnailSlider.scrollLeft += e.deltaY > 0 ? 120 : -120;
  }
};

document.addEventListener('wheel', thumbnailSlider._wheelHandler, { passive: false });

    thumbnailSlider.addEventListener('wheel', thumbnailSlider._wheelHandler, { passive: false });
  }

  // ── Run on DOMContentLoaded ──
  adjustThumbnailSliderWidth();

  window.addEventListener('resize', adjustThumbnailSliderWidth);

  const images = document.querySelectorAll('.product__media-item img');
  if (images.length > 0) {
    images[0].addEventListener('load', adjustThumbnailSliderWidth);
  }

  // ── Run setupThumbnailHoverScroll after full page load ──
  window.addEventListener('load', function () {
    setupThumbnailHoverScroll();
    setTimeout(setupThumbnailHoverScroll, 500);
    setTimeout(setupThumbnailHoverScroll, 1500);
  });

});
